import { Paper } from '@mui/material'
import { useEffect } from 'react'
import { STATS_TABS } from '../../../components/navigation'
import { NavTabs, useNavTabs } from '../../../components/navigation/NavTabs'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import GameHistory from '../../Profile/components/GameHistory'

import { GuestBlocker } from '../components/rewards/GuestBlocker'
import { StatsWrapper } from '../components/StatsWrapper'

const STATS_CONTENT = {
    [STATS_TABS.STATS]: <StatsWrapper />,
    [STATS_TABS.HISTORY]: <GameHistory />,
}

export const Stats = () => {
    const settings = useStoreState((state) => state.gameView.settings)
    const initStats = useStoreActions((state) => state.profileView.initStats)
    const { currentTab } = useNavTabs(STATS_TABS)

    useEffect(() => {
        initStats()
    }, [settings.friendlyMode])

    return (
        <>
            <NavTabs tabs={STATS_TABS} />

            <Paper
                sx={{
                    display: 'flex',
                    flexGrow: 1,
                    height: { xs: 'calc(100dvh - 366px)', sm: 'calc(100dvh - 326px)', md: 'calc(100% - 48px)' },
                    overflow: 'auto',
                    position: 'relative',
                }}
                variant="outlined"
            >
                <GuestBlocker />
                {STATS_CONTENT[currentTab]}
            </Paper>
        </>
    )
}
